import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStores } from '../../../hooks/use-stores';
import { useState } from 'react';

const ModelAutocomplete = observer(({ name, value, onChange }) => {
    const { OrderStore: store } = useStores();
    const { productId } = useParams();
    const [model, setModel] = useState(null);

    useEffect(() => {
        store.getProductModels(productId);
    }, [productId, store]);

    useEffect(() => {
        onChange(name, model?.id);
    }, [model, name, onChange]);

    return (
        <Autocomplete
            popupIcon={<ExpandMoreIcon />}
            options={store.models}
            loading={store.loading}
            getOptionLabel={model => model.name}
            value={model}
            onChange={(e, value) => setModel(value)}
            renderInput={params => <TextField {...params} fullWidth label="Выберите модель" required />}
            noOptionsText="Нет данных"
            loadingText="Загрузка..."
        />
    );
});

export default ModelAutocomplete;
